import React from "react";
import Nav from "../components/nav/nav";
import StudentTab from "../components/tabs/tabs";

const StudentPage = () => {
  return (
    <div>
     <Nav/>
     <StudentTab/>

    </div>
  );
}

export default StudentPage;